import type {
  CellViolationInfo,
  DetailedViolation,
  ViolationGroupInfo,
} from "./types";

export function getOrCreateCell(
  map: Map<string, CellViolationInfo>,
  key: string
): CellViolationInfo {
  const existing = map.get(key);
  if (existing) return existing;

  const cell: CellViolationInfo = {
    isError: false,
    messages: [],
    typedMessages: [],
    groups: [],
  };
  map.set(key, cell);
  return cell;
}

export function addViolationMessage(
  cell: CellViolationInfo,
  violation: DetailedViolation,
  message: string | null
): void {
  if (!message) return;
  cell.messages.push(message);
  cell.typedMessages.push({ type: violation.type, message });
}

export function addViolationGroup(
  cell: CellViolationInfo,
  group: ViolationGroupInfo | null
): void {
  if (!group) return;
  const hasDuplicate = cell.groups.some(
    (existing) =>
      existing.type === group.type && existing.startDay === group.startDay
  );
  if (!hasDuplicate) {
    cell.groups.push(group);
  }
}
